class MiniCart extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.header = document.querySelector('sticky-header');
    this.drawer = document.querySelector('cart-drawer');
    new IntersectionObserver(this.handleIntersection.bind(this)).observe(this);
  }

  handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);

    fetch(this.dataset.url)
      .then(response => response.text())
      .then(html => {
        document.getElementById('mini-cart').innerHTML =
          this.getSectionInnerHTML(html, '.shopify-section');
          
          document.dispatchEvent(new CustomEvent('cartdrawer:opened'));
         function getUTMs() {
     const urlParams = new URLSearchParams(window.location.search);
     const utmSource = urlParams.get('utm_source');
     const utmMedium = urlParams.get('utm_medium');
     const utmCampaign = urlParams.get('utm_campaign');
     const utmTerm = urlParams.get('utm_term');
     const utmContent = urlParams.get('utm_content');
     let utmString = '';
   
     if (utmSource) {
         utmString += `utm_source=${utmSource}`;
     }
   
     if (utmMedium) {
         utmString += utmString ? `&utm_medium=${utmMedium}` : `utm_medium=${utmMedium}`;
     }
   
     if (utmCampaign) {
         utmString += utmString ? `&utm_campaign=${utmCampaign}` : `utm_campaign=${utmCampaign}`;
     }
     if(utmTerm){
       utmString += utmString ? `&utm_term=${utmTerm}` : `utm_term=${utmTerm}`;
     }
    if(utmContent){
       utmString += utmString ? `&utm_content=${utmContent}` : `utm_content=${utmContent}`;
     }
     return utmString || '';
 }






 class CartWatcher {


 init() {
   this.emitCartChanges().then(() => {
     this.observeCartChanges();
   });
 }


 async fetchCart() {
   const response = await fetch('/cart.js');
   return response.json();
 }


 storeCart(cart) {
   localStorage.setItem('cart', JSON.stringify(cart));
 }


storedCart() {
   return JSON.parse(localStorage.getItem('cart')) || { items: [] };
 }


findCartChanges(oldCart, newCart) {
   const onlyInLeft = (l, r) => l.filter(li => !r.some(ri => li.key == ri.key));
   let result = {
     added: onlyInLeft(newCart.items, oldCart.items),
     removed: onlyInLeft(oldCart.items, newCart.items),
   };


   oldCart.items.forEach(oi => {
     const ni = newCart.items.find(i => i.key == oi.key && i.quantity != oi.quantity);
     if (!ni) return;
     let quantity = ni.quantity - oi.quantity;
     let item = { ...ni };
     item.quantity = Math.abs(quantity);
     quantity > 0
       ? result.added.push(item)
       : result.removed.push(item)
   });


   return result;
 }


 async emitCartChanges() {
   const newCart = await this.fetchCart();
   const oldCart = this.storedCart();
   const changes = this.findCartChanges(oldCart, newCart);


   const event = new CustomEvent("cart_changed", { detail: changes });
   window.dispatchEvent(event);


   this.storeCart(newCart);
 }


observeCartChanges() {
   const cartObserver = new PerformanceObserver((list) => {
     list.getEntries().forEach((entry) => {
       const isValidRequestType = ['xmlhttprequest', 'fetch'].includes(entry.initiatorType);
       const isCartChangeRequest = /\/cart\//.test(entry.name);
       if (isValidRequestType && isCartChangeRequest) {
         this.emitCartChanges();
       }
     });
   });
   cartObserver.observe({ entryTypes: ["resource"] });
 }
}


 const myCartWatcher = new CartWatcher;
 myCartWatcher.init();
 // window.addEventListener("cart_changed", e => console.log(e.detail));
  window.addEventListener("cart_changed", e => {
     console.log(e.detail);
     fetchCartAndHandleButton();


   });


//-----
 function showLoading() {
 
 document.getElementById("checkoutB4").innerHTML = `
  <svg style="width:30px;height:30px; animation: spin 1s linear infinite;" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
 <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4" style="stroke-dasharray: 80; stroke-dashoffset: 60; stroke-linecap: round;"></circle>
 <style>
   @keyframes spin {
     0% {
       transform: rotate(0deg);
     }
     100% {
       transform: rotate(360deg);
     }
   }
 </style>
</svg>


 `;
 document.getElementById("checkoutB4").style.pointerEvents = 'none';
}


function restoreOriginalContent() {
 document.getElementById("checkoutB4").innerHTML = 'Finalizar a Compra';
 document.getElementById("checkoutB4").style.pointerEvents = 'auto';
}
//-----
function fetchCartAndHandleButton(frete) {
   showLoading();


 fetch(window.Shopify.routes.root + 'cart.js')
   .then(response => response.json())
   .then(data => {
     if (data && Array.isArray(data.items)) {
       let metadata = {
         line_items: []
       };


      console.log('Dados originais:', data);


       //-------------------
       const offerData = {
         uuid: '1ff6f02e-d467-4ace-ae05-c10028a731f4',
         name: '',
         price: 0,
         description: 'Descrição da oferta Império',
         banner_image: 'https://example.com/banner.jpg',
         start_offer: '2024-04-01',
         end_offer: '2028-12-15',
         payment_methods: 'credit_card,billet,pix',
         allow_affiliate: true,
         discount_pix: 0,
         installments: 6,
         shipping_price: 0,
         shipping_type: 3,
         metadata: '',
         offer_image: [],
         student_pays_interest: true,
     
       };


       const url = 'http://api-checkout.b4you.com.br/api/checkout/offers/offerByShopify';       
     
       data.items.forEach(item => {
     
         metadata.line_items.push({
           title: item.title,
           variant_id: item.variant_id,
           price: (item.final_price / 100).toFixed(2),
           grams: item.grams || '0',
           quantity: item.quantity
         });
         offerData.metadata = metadata;
         offerData.offer_image.push({ image: item.image , variant_id: item.variant_id });
         const titlePrefix = item.quantity > 1 ? `${item.quantity}x ` : '';
         offerData.name += `${titlePrefix}${item.title} + `;
         offerData.name = offerData.name.replace(/'/g, "");
         offerData.name = offerData.name.replace("&#39;", "");
         const itemPrice = item.final_price * item.quantity;
         offerData.price += itemPrice;
         //-----
         offerData.banner_image = item.featured_image.url;
       });


       offerData.name = offerData.name.slice(0, -3);
       offerData.price /= 100;
       offerData.price = offerData.price.toFixed(2);


       offerData.shipping_price = offerData.price > 129 ? 0 : 19.90;
       console.log('Dados da oferta:', offerData);
       console.log('Metadata:', metadata);
       if(offerData.price > 0){
         fetch(url, {
           method: 'POST',
           headers: {
             'Content-Type': 'application/json',
           },
           body: JSON.stringify(offerData),
         })
           .then(response => {
             if (!response.ok) {
               throw new Error('Erro ao criar oferta');
             }
             return response.json();
           })
           .then(data => {
             console.log('Oferta criada com sucesso:', data);
             if (data.hasOffer || data.newOffer) {
               localStorage.setItem('urlCheckout', data.hasOffer ? data.hasOffer.uuid : data.newOffer.uuid);
               var urlCheckoutUpdate = localStorage.getItem("urlCheckout");
               if (urlCheckoutUpdate) {
                 var checkoutLinkUpdate = document.getElementById("checkoutB4");
                 const utmsConcatenadas = getUTMs();
                 checkoutLinkUpdate.href = 'https://checkout.b4you.com.br/' + urlCheckoutUpdate + '/1';
                 if (utmsConcatenadas) {
                   checkoutLinkUpdate.href = 'https://checkout.b4you.com.br/' + urlCheckoutUpdate + '/1/' + '?' + utmsConcatenadas;
                 
                 }
               }
             }
               restoreOriginalContent();
           })
           .catch(error => {
             console.error('Erro ao criar oferta:', error);
             restoreOriginalContent();
           });
       }else{
         console.log('verifique carrinho vazio');


       }
     
     } else {
       console.error('Dados do carrinho inválidos ou ausentes.');
       restoreOriginalContent();
     }
   })
   .catch(error => {
     console.error('Erro ao buscar dados do carrinho:', error);
     restoreOriginalContent();
   });
}
document.addEventListener('DOMContentLoaded', function () {
   fetchCartAndHandleButton();
 });
      })
      .catch(e => {
        console.error(e);
      });
  }

  open() {
    const detailsElement = this.drawer.querySelector('details');
    if (detailsElement.hasAttribute('open')) {
      
      return;
    }
    
    this.drawer.openMenuDrawer();
  }

  renderContents(parsedState) {
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      if (document.getElementById(section.id)) {
        document.getElementById(section.id).innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      }
    }));

    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'mini-cart',
        section: 'mini-cart',
        selector: '.shopify-section'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'mobile-cart-icon-bubble',
        section: 'mobile-cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }
}

customElements.define('mini-cart', MiniCart);
